import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: ":templateId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "external-assessment-template-details" */ "./components"
      ),
    ]).then(([importedModule0]) => importedModule0.default)
  ),
});
